import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#332969',
        secondary: '#f5780c',
        accent: '#eeee14'
      }
    }
  }
})
